var map = {
	"./fondo-banner.svg": 8355,
	"./fondo-cobertura.svg": 5934,
	"./fonto-estaciones.svg": 9372,
	"./fonts/JosefinSans/josefinsans-bold-webfont.woff": 3179,
	"./fonts/JosefinSans/josefinsans-bold-webfont.woff2": 1833,
	"./fonts/JosefinSans/josefinsans-bolditalic-webfont.woff": 8435,
	"./fonts/JosefinSans/josefinsans-bolditalic-webfont.woff2": 5634,
	"./fonts/JosefinSans/josefinsans-italic-webfont.woff": 3270,
	"./fonts/JosefinSans/josefinsans-italic-webfont.woff2": 8076,
	"./fonts/JosefinSans/josefinsans-light-webfont.woff": 992,
	"./fonts/JosefinSans/josefinsans-light-webfont.woff2": 864,
	"./fonts/JosefinSans/josefinsans-lightitalic-webfont.woff": 595,
	"./fonts/JosefinSans/josefinsans-lightitalic-webfont.woff2": 8754,
	"./fonts/JosefinSans/josefinsans-regular-webfont.woff": 4924,
	"./fonts/JosefinSans/josefinsans-regular-webfont.woff2": 6241,
	"./fonts/JosefinSans/josefinsans-semibold-webfont.woff": 4509,
	"./fonts/JosefinSans/josefinsans-semibold-webfont.woff2": 7434,
	"./fonts/JosefinSans/josefinsans-semibolditalic-webfont.woff": 9442,
	"./fonts/JosefinSans/josefinsans-semibolditalic-webfont.woff2": 5874,
	"./footer-background.svg": 6696,
	"./footer.svg": 1997,
	"./logo-8ntv.png": 9609,
	"./logo-exa-puerto-vallarta.png": 9340,
	"./logo-grupo-alica.png": 122,
	"./logo-la-mejor-ixtlan.png": 9629,
	"./logo-la-mejor-tepic.png": 8635,
	"./logo-la-patrona-acaponeta.png": 4272,
	"./logo-la-patrona-compostela.png": 7478,
	"./logo-la-patrona-escuinapa.png": 4000,
	"./logo-la-patrona-santiago.png": 9161,
	"./logo-la-patrona-vallarta.png": 304,
	"./logo-meridiano.png": 2440,
	"./logo-ntv.png": 8564,
	"./logo-ntvplus-resized.png": 9065,
	"./logo.png": 6949,
	"./mapa-cobertura.png": 5201,
	"./mision.jpg": 9500,
	"./vision.webp": 8782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;